export enum EnvironmentName {
  DEV = 'dev',
  E2E = 'e2e',
  STAGING = 'staging',
  DEMO = 'demo',
  PROD = 'prod',
}

export enum AppName {
  EMMA_APP = 'emma-app',
  ADVISOR = 'advisor',
  EMMA_PRO = 'emma-pro',
}

export const APP_NAME_HEADER_KEY = 'x-app-name';

export enum ApiBaseUrl {
  DEMO = 'https://api.demo.emma.ca',
  STAGING = 'https://api.staging.emma.ca',
  PROD = 'https://api.emma.ca',
  LOCAL = 'http://api.emma.localhost',
}

export const isDev = (environment: EnvironmentName): boolean =>
  environment === EnvironmentName.DEV || environment === EnvironmentName.E2E;

export const isE2E = (environment: EnvironmentName): boolean => environment === EnvironmentName.E2E;

export const isProd = (environment: EnvironmentName): boolean => environment === EnvironmentName.PROD;
